var _style, _g, _g2, _g3;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgButterfly1 = function SvgButterfly1(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ektnm2c5t451",
    viewBox: "0 0 100 100",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "@keyframes ektnm2c5t452_to__to{0%,98%,to{transform:translate(49.999998px,59.355567px)}9%{transform:translate(49.999998px,60.109758px)}18%{transform:translate(49.999997px,57.899111px)}24%{transform:translate(49.999998px,57.266194px)}41.6%{transform:translate(49.999997px,57.903533px)}44%{transform:translate(49.999997px,57.899288px)}49.6%,52.4%{transform:translate(49.999997px,57.189744px)}72%{transform:translate(49.999997px,58.975811px)}80%{transform:translate(49.999997px,57.800202px)}}@keyframes ektnm2c5t453_ts__ts{0%,10.4%,34%,48.2%,82%,to{transform:translate(25px,25px) scale(1,1)}6%{transform:translate(25px,25px) scale(1,1);animation-timing-function:cubic-bezier(.39,.575,.565,1)}8%{transform:translate(25px,25px) scale(.417924,1)}11.8%,30.8%,46.2%{transform:translate(25px,25px) scale(.395834,1)}15.8%,28%,44%{transform:translate(25px,25px) scale(1,1);animation-timing-function:cubic-bezier(.445,.05,.55,.95)}70%,76%{transform:translate(25px,25px) scale(1,1);animation-timing-function:cubic-bezier(.955,.97,.32,1.275)}74%{transform:translate(25px,25px) scale(.395834,1);animation-timing-function:cubic-bezier(.42,0,.58,1)}78%{transform:translate(25px,25px) scale(.59097,1)}}@keyframes ektnm2c5t4513_ts__ts{0%,10.4%,34%,48.2%,82%,to{transform:translate(25px,25px) scale(1,1)}6%{transform:translate(25px,25px) scale(1,1);animation-timing-function:cubic-bezier(.39,.575,.565,1)}11.8%,30.8%,46.2%,8%{transform:translate(25px,25px) scale(.395834,1)}15.8%,28%,44%{transform:translate(25px,25px) scale(1,1);animation-timing-function:cubic-bezier(.445,.05,.55,.95)}70%,76%{transform:translate(25px,25px) scale(1,1);animation-timing-function:cubic-bezier(.955,.97,.32,1.275)}74%{transform:translate(25px,25px) scale(.395834,1);animation-timing-function:cubic-bezier(.42,0,.58,1)}78%{transform:translate(25px,25px) scale(.59097,1)}}")), /*#__PURE__*/React.createElement("g", {
    transform: "translate(50 59.36)",
    style: {
      animation: "ektnm2c5t452_to__to 5000ms linear infinite normal forwards"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "ektnm2c5t452",
    transform: "rotate(26.79 65 -40)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(25 25)",
    style: {
      animation: "ektnm2c5t453_ts__ts 5000ms linear infinite normal forwards"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ektnm2c5t453",
    transform: "translate(-25 -25)",
    stroke: "none",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("path", {
    id: "ektnm2c5t454",
    d: "M94.77 93.49c-6.23-6.58-13.84-9.86-17.87-7.89-4.03 1.97-2.6 14.55 8.28 21.61-4.33 3.19-1.22 6.85.95 7.82 0 0-4 5.88-1.84 6.36 2.16.48 4.33-5.64 4.33-5.64 2.48.49 5.58-1.48 6.82-3.44z",
    transform: "translate(-70.66 -77.43)",
    fill: "#3B2314"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ektnm2c5t455",
    d: "M93.38 95.33c-4-3.17-9.34-8.41-12.28-6.69-2.94 1.72-.9 11 5.63 14.9-1.24 1.84 1.57 7.45 7.3 4.74z",
    transform: "translate(-70.66 -77.43)",
    fill: "#CA892E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ektnm2c5t456",
    d: "M90.89 92.65s-2.32 4.65-.92 5c1.4.35 2.16-4.41 2.16-4.41z",
    transform: "translate(-70.66 -77.43)",
    fill: "#3B2314"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ektnm2c5t457",
    d: "M88.71 90.45s-.61 5.26-1.85 5.14c-1.24-.12.6-5.86.6-5.86z",
    transform: "translate(-70.66 -77.43)",
    fill: "#3B2314"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ektnm2c5t458",
    d: "M85.76 88.87s.16 3.3-1.24 3.31c-1.4.01 0-4 0-4z",
    transform: "translate(-70.66 -77.43)",
    fill: "#3B2314"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ektnm2c5t459",
    d: "M91.38 102.67a1.09 1.09 0 11-2.18-.02 1.09 1.09 0 012.18.02z",
    transform: "translate(-70.66 -77.43)",
    fill: "#3B2314"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ektnm2c5t4510",
    d: "M92.8 112.2a.93.93 0 11-.93-.86.89.89 0 01.93.86z",
    transform: "translate(-70.66 -77.43)",
    fill: "#CA892E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ektnm2c5t4511",
    d: "M89.7 112.45a.9.9 0 01-.93.86.86.86 0 110-1.71.9.9 0 01.93.85z",
    transform: "translate(-70.66 -77.43)",
    fill: "#CA892E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ektnm2c5t4512",
    d: "M87.21 110.63a.93.93 0 11-.93-.86.89.89 0 01.93.86z",
    transform: "translate(-70.66 -77.43)",
    fill: "#CA892E"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(25 25)",
    style: {
      animation: "ektnm2c5t4513_ts__ts 5000ms linear infinite normal forwards"
    }
  }, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "ektnm2c5t4513",
    transform: "translate(-25 -24.2)",
    stroke: "none",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("path", {
    id: "ektnm2c5t4514",
    d: "M96.57 92.75c6.19-6.62 13.79-9.94 17.83-8 4.04 1.94 2.68 14.54-8.17 21.66 4.35 3.16 1.26 6.84-.91 7.82 0 0 4.05 5.86 1.88 6.35-2.17.49-4.36-5.6-4.36-5.6-2.48.49-5.59-1.45-6.84-3.41z",
    transform: "translate(-70.66 -77.43)",
    fill: "#3B2314"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ektnm2c5t4515",
    d: "M98 94.58c4-3.19 9.29-8.46 12.25-6.76 2.96 1.7 1 11-5.55 14.93 1.24 1.83-1.53 7.46-7.28 4.79z",
    transform: "translate(-70.66 -77.43)",
    fill: "#CA892E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ektnm2c5t4516",
    d: "M100.45 91.88s2.34 4.64.94 5c-1.4.36-2.18-4.39-2.18-4.39z",
    transform: "translate(-70.66 -77.43)",
    fill: "#3B2314"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ektnm2c5t4517",
    d: "M100 101.91a1.09 1.09 0 102.18-.04 1.09 1.09 0 00-2.18.04z",
    transform: "translate(-70.66 -77.43)",
    fill: "#3B2314"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ektnm2c5t4518",
    d: "M101.74 111.68a.94.94 0 10.93-.86.9.9 0 00-.93.86z",
    transform: "translate(-70.66 -77.43)",
    fill: "#CA892E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ektnm2c5t4519",
    d: "M98.64 111.44a.93.93 0 10.93-.85.9.9 0 00-.93.85z",
    transform: "translate(-70.66 -77.43)",
    fill: "#CA892E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ektnm2c5t4520",
    d: "M104.22 109.84a.93.93 0 10.93-.86.9.9 0 00-.93.86z",
    transform: "translate(-70.66 -77.43)",
    fill: "#CA892E"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "ektnm2c5t4521"
  }, /*#__PURE__*/React.createElement("path", {
    id: "ektnm2c5t4522",
    d: "M94.61 91.66c-1.08 2.57-2.57 24.45 1.31 24.44 3.88-.01 1.19-17.24.86-23.72z",
    transform: "translate(-70.66 -77.43)",
    fill: "#3B2314",
    stroke: "none",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "ektnm2c5t4523",
    d: "M98.33 90.91a2.71 2.71 0 11-2.64-2.07c1.3-.14 2.46.78 2.64 2.07z",
    transform: "translate(-70.66 -77.43)",
    fill: "#3B2314",
    stroke: "none",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "ektnm2c5t4524",
    d: "M24.26 12.64c0-2.94-3.12-6.1-5.76-5.6",
    fill: "none",
    stroke: "#3B2314",
    strokeWidth: 0.41,
    strokeLinecap: "round",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "ektnm2c5t4525",
    d: "M26.12 12.88c1.08-2.94 2.3-6.37 5.57-6.87",
    fill: "none",
    stroke: "#3B2314",
    strokeWidth: 0.41,
    strokeLinecap: "round",
    strokeMiterlimit: 10
  }))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgButterfly1, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/butterfly1.f4daff03.svg";
export { ForwardRef as ReactComponent };